/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DutyScheduleDistributionRowResponse } from './DutyScheduleDistributionRowResponse';
import {
    DutyScheduleDistributionRowResponseFromJSON,
    DutyScheduleDistributionRowResponseFromJSONTyped,
    DutyScheduleDistributionRowResponseToJSON,
    DutyScheduleDistributionRowResponseToJSONTyped,
} from './DutyScheduleDistributionRowResponse';
import type { DutyScheduleDistributionMetricsResponse } from './DutyScheduleDistributionMetricsResponse';
import {
    DutyScheduleDistributionMetricsResponseFromJSON,
    DutyScheduleDistributionMetricsResponseFromJSONTyped,
    DutyScheduleDistributionMetricsResponseToJSON,
    DutyScheduleDistributionMetricsResponseToJSONTyped,
} from './DutyScheduleDistributionMetricsResponse';
import type { DutyScheduleDistributionPeriodResponse } from './DutyScheduleDistributionPeriodResponse';
import {
    DutyScheduleDistributionPeriodResponseFromJSON,
    DutyScheduleDistributionPeriodResponseFromJSONTyped,
    DutyScheduleDistributionPeriodResponseToJSON,
    DutyScheduleDistributionPeriodResponseToJSONTyped,
} from './DutyScheduleDistributionPeriodResponse';

/**
 * 
 * @export
 * @interface DutyScheduleDistributionSummaryResponse
 */
export interface DutyScheduleDistributionSummaryResponse {
    /**
     * 
     * @type {Array<DutyScheduleDistributionRowResponse>}
     * @memberof DutyScheduleDistributionSummaryResponse
     */
    rows: Array<DutyScheduleDistributionRowResponse>;
    /**
     * 
     * @type {Array<DutyScheduleDistributionPeriodResponse>}
     * @memberof DutyScheduleDistributionSummaryResponse
     */
    periodComparison: Array<DutyScheduleDistributionPeriodResponse>;
    /**
     * 
     * @type {DutyScheduleDistributionMetricsResponse}
     * @memberof DutyScheduleDistributionSummaryResponse
     */
    metrics: DutyScheduleDistributionMetricsResponse;
}

/**
 * Check if a given object implements the DutyScheduleDistributionSummaryResponse interface.
 */
export function instanceOfDutyScheduleDistributionSummaryResponse(value: object): value is DutyScheduleDistributionSummaryResponse {
    if (!('rows' in value) || value['rows'] === undefined) return false;
    if (!('periodComparison' in value) || value['periodComparison'] === undefined) return false;
    if (!('metrics' in value) || value['metrics'] === undefined) return false;
    return true;
}

export function DutyScheduleDistributionSummaryResponseFromJSON(json: any): DutyScheduleDistributionSummaryResponse {
    return DutyScheduleDistributionSummaryResponseFromJSONTyped(json, false);
}

export function DutyScheduleDistributionSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DutyScheduleDistributionSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rows': ((json['rows'] as Array<any>).map(DutyScheduleDistributionRowResponseFromJSON)),
        'periodComparison': ((json['periodComparison'] as Array<any>).map(DutyScheduleDistributionPeriodResponseFromJSON)),
        'metrics': DutyScheduleDistributionMetricsResponseFromJSON(json['metrics']),
    };
}

export function DutyScheduleDistributionSummaryResponseToJSON(json: any): DutyScheduleDistributionSummaryResponse {
    return DutyScheduleDistributionSummaryResponseToJSONTyped(json, false);
}

export function DutyScheduleDistributionSummaryResponseToJSONTyped(value?: DutyScheduleDistributionSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rows': ((value['rows'] as Array<any>).map(DutyScheduleDistributionRowResponseToJSON)),
        'periodComparison': ((value['periodComparison'] as Array<any>).map(DutyScheduleDistributionPeriodResponseToJSON)),
        'metrics': DutyScheduleDistributionMetricsResponseToJSON(value['metrics']),
    };
}

